import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './DataProtectionNotice.css';

const DataProtectionNotice = () => {
  const { joinNoticeText } = useLanguage();

  if (!joinNoticeText?.trim()) {
    return null;
  }

  return (
    <div className="data-protection-notice">
      <p>{joinNoticeText}</p>
    </div>
  );
};

export default DataProtectionNotice;
